import {
  faAlarmClock,
  faArchive,
  faArrowDownToLine,
  faArrowLeftLong,
  faArrowRightLong,
  faArrows,
  faBook,
  faBullseyeArrow,
  faCalendarAlt,
  faCertificate,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faCog,
  faCommentsAlt,
  faCreditCard,
  faEnvelope,
  faExternalLink,
  faFileCheck,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileInvoice,
  faFileMagnifyingGlass,
  faFilePdf,
  faFilePlus,
  faFileSignature,
  faFileUpload,
  faFileWord,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faHashtag,
  faHourglassStart,
  faIdCard,
  faKey,
  faMagnifyingGlass,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPencil,
  faPlus,
  faPowerOff,
  faQuestionSquare,
  faShare,
  faSlidersV,
  faSquare,
  faTasks,
  faTrash,
  faTrashCan,
  faUpload,
  faUser,
  faUserFriends,
  faUserShield,
  faUsers,
  faXmark,
} from '@awesome.me/kit-da13514c94/icons/classic/light'

export const lightLibrary = [
  faAlarmClock,
  faArchive,
  faArrowDownToLine,
  faArrowLeftLong,
  faArrowRightLong,
  faArrows,
  faBook,
  faBullseyeArrow,
  faCalendarAlt,
  faCertificate,
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faCircleCheck,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faCog,
  faCommentsAlt,
  faCreditCard,
  faEnvelope,
  faExternalLink,
  faFileCheck,
  faFileDownload,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileInvoice,
  faFileMagnifyingGlass,
  faFilePdf,
  faFilePlus,
  faFileSignature,
  faFileUpload,
  faFileWord,
  faFolder,
  faFolderOpen,
  faFolderUpload,
  faHashtag,
  faHourglassStart,
  faIdCard,
  faKey,
  faMagnifyingGlass,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPencil,
  faPlus,
  faPowerOff,
  faQuestionSquare,
  faShare,
  faSlidersV,
  faSquare,
  faTasks,
  faTrash,
  faTrashCan,
  faUpload,
  faUser,
  faUserFriends,
  faUserShield,
  faUsers,
  faXmark,
]
